export const enum YouTubeThumbnailQuality {
  Default = 'default',
  HQDefault = 'hqdefault',
}

const YOUTUBE_IMG_URL = '//img.youtube.com/vi';

export const getYouTubeImageUrl = (id: string, quality: YouTubeThumbnailQuality) =>
  `${YOUTUBE_IMG_URL}/${id}/${quality}.jpg`;
